import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import http from '../../api/http';

const fetchProfile = async () => {
  const {
    data: { data },
  } = await http.get('/user/profile');
  return data;
};
const updateProfile = async (payload) => {
  const {
    data: { data },
  } = await http.put('/user/profile', payload);
  return data;
};
export const useFetchProfile = () => {
  return useQuery({
    queryKey: ['fetchProfile'],
    queryFn: fetchProfile,
  });
};
// When this mutation succeeds, invalidate query with the `fetchProfile` query key
export const useUpdateProfile = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateProfile,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['fetchProfile'] });
    },
  });
};
